import React from 'react';
import PropTypes from 'prop-types';

import ControlLabelTooltip from '@/components/common/ControlLabelTooltip';
import {
    twitterShareUrl,
    facebookShareUrl,
    linkedInShareUrl,
    buildShareText,
} from '@/shared/utils/shareUrls';

/**
 * Social media share buttons for post permalink pages.
 * Renders Twitter/X, Facebook, and LinkedIn share links.
 */
const ShareButtons = ({ url, title, communityName }) => {
    const shareText = buildShareText(title, communityName);

    const platforms = [
        {
            name: 'Twitter',
            href: twitterShareUrl(url, shareText),
            icon: 'bi-twitter-x',
            label: 'Share on Twitter / X',
        },
        {
            name: 'Facebook',
            href: facebookShareUrl(url),
            icon: 'bi-facebook',
            label: 'Share on Facebook',
        },
        {
            name: 'LinkedIn',
            href: linkedInShareUrl(url),
            icon: 'bi-linkedin',
            label: 'Share on LinkedIn',
        },
    ];

    return (
        <div
            className="d-flex align-items-center gap-2"
            role="group"
            aria-label="Share this post"
        >
            <span className="text-muted small me-1">Share:</span>
            {platforms.map(({ name, href, icon, label }) => (
                <ControlLabelTooltip key={name} label={label}>
                    <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1"
                        aria-label={label}
                    >
                        <i className={`bi ${icon}`} aria-hidden="true" />
                        <span className="d-none d-sm-inline">{name}</span>
                    </a>
                </ControlLabelTooltip>
            ))}
        </div>
    );
};

ShareButtons.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    communityName: PropTypes.string,
};

export default ShareButtons;
